import { TimeHelper } from "../../helpers/TimeHelper";

class OrganisationBatteryModel {
  batteryId;
  batteryShipDate;
  batteryQuantity;
  batteryComments;

  constructor(data) {
    this.populate(data || {
      batteryQuantity: 1,
      batteryComments: ''
    });
  }

  populate(data) {
    this.batteryId = data.batteryId;
    this.batteryShipDate = data.batteryShipDate;
    this.batteryQuantity = data.batteryQuantity;
    this.batteryComments = data.batteryComments;
  }

  toJson() {
    const output = {};
    output.batteryShipDate = this.batteryShipDate;
    output.batteryQuantity = this.batteryQuantity;
    output.batteryComments = this.batteryComments;
    output.batteryId = this.batteryId;
  
    return output;
  }
}

export { OrganisationBatteryModel };